import { useState, useEffect } from 'react';

export function useAnimationBlock() {
    const [animationBlock, setAnimationBlock] = useState("");
    const [rotateChevron, setRotateChevron] = useState(false);

    const openBlock = async () => {
        setRotateChevron(!rotateChevron);
        let css = !rotateChevron ? "hide_block" : ""
        setAnimationBlock(css)
    }

    return { animationBlock, openBlock, rotateChevron };
}
